module.exports = __webpack_public_path__ + "assets/bdc57d4ef5652f5b4b6f8f788e3ef286.mp4";